module.exports = __webpack_public_path__ + "img/sumup1.1da8e338.png";